import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import styled from 'styled-components';
import { Layout, Header, Footer } from "../components";
import { contentfulClient } from "../utils/contentfulClient";

class TermsPage extends Component {
  static propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    keywords: PropTypes.string,
    body: PropTypes.instanceOf(Object),
  };

  static async getInitialProps() {
    const data = await contentfulClient.getEntry('6FFmS5LCsaidzJ722hVgPb');

    return { ...data.fields };
  };

  render() {
    const { title, description, keywords, body } = this.props;

    const Container = styled.main`
      padding: 25px;
      
      a {
        color: ${({ theme }) => theme.blue};
        
        transition: color 0.3s;
        
        &:hover {
          color: ${({ theme }) => theme.black};
        }
      }
      
      @media (min-width: 768px) {
        max-width: 1210px;
        margin: 0 auto;
        padding: 40px;
      }
    `;

    return (
      <Layout heading={title} description={description} metaKeywords={keywords}>
        <Header isInnerPage fixed />
        <Container dangerouslySetInnerHTML={{ __html: documentToHtmlString(body) }} />
        <Footer isInnerPage />
      </Layout>
    );
  }
}

export default TermsPage;
